export default __webpack_public_path__ + "static/media/xsbox.16960fc8.svg";